// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"errorResult_wrapper__pDAP5"};